import { defineComponent } from 'vue';

/**
 * Properties panel for Control Designer dock tab. Defers content mount until the tab is active
 * and the host element is in the document (avoids empty panel on inactive dock tabs).
 */
export default defineComponent({
    name: 'ControlDesignerPropertiesPanel',
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        mountKey: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            showContent: false,
        };
    },
    watch: {
        active: {
            immediate: true,
            handler(active) {
                this.scheduleContentMount(active);
            },
        },
        mountKey() {
            this.scheduleContentMount(this.active);
        },
    },
    beforeUnmount() {
        if (this._mountTimer != null) {
            clearTimeout(this._mountTimer);
            this._mountTimer = null;
        }
    },
    methods: {
        scheduleContentMount(active) {
            if (this._mountTimer != null) {
                clearTimeout(this._mountTimer);
                this._mountTimer = null;
            }

            if (!active) {
                this.showContent = false;
                return;
            }

            this.showContent = false;
            this._mountTimer = setTimeout(() => {
                this._mountTimer = null;
                requestAnimationFrame(() => {
                    if (this.active)
                        this.showContent = true;
                });
            }, 0);
        },
    },
    render() {
        const panelStyle = {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            height: '100%',
            minHeight: 0,
            borderStyle: 'solid',
            borderWidth: '1px',
            boxSizing: 'border-box',
            overflow: 'auto',
        };

        return (
            <div class="control-designer-properties-panel" style={panelStyle}>
                {this.showContent ? (
                    <div
                        key={`controlDesignerProperties-${this.mountKey}`}
                        style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, height: '100%', minHeight: 0 }}
                    >
                        {this.$slots.default?.()}
                    </div>
                ) : null}
            </div>
        );
    },
});
